import { Fragment, isValidElement } from 'react';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import {
  List,
  MenuItem,
  ListItemIcon,
  Typography,
  Collapse,
  Tooltip,
} from '@mui/material';
import { useTranslate } from 'react-admin';
import { customPalette } from '../themes/customTheme';

const RenderIcon = ({ icon }) => {
  if (isValidElement(icon)) {
    return icon;
  }

  if (typeof icon === 'function') {
    const IconComponent = icon;
    return <IconComponent />;
  }

  return null;
};

const SubMenu = ({
  handleToggle,
  sidebarIsOpen,
  isOpen,
  active,
  name,
  icon,
  children,
  dense,
}) => {
  const translate = useTranslate();

  const header = (
    <MenuItem
      dense={dense}
      component="ul"
      onClick={handleToggle}
      sx={{
        padding: '6px 16px',
        borderLeft: active
          ? `3px solid ${customPalette.primary.main}`
          : '3px solid #fff',
        transition: 'all 195ms cubic-bezier(0.4, 0, 0.6, 1)',
        '&:hover': {
          backgroundColor: 'rgba(0,0,0,0.04)',
        },
      }}
      className={isOpen ? 'selected' : ''}
    >
      <ListItemIcon sx={{ minWidth: '40px', marginRight: '4px' }}>
        {isOpen ? <ExpandMoreRoundedIcon /> : <RenderIcon icon={icon} />}
      </ListItemIcon>
      <Typography
        variant="inherit"
        color="textSecondary"
        sx={{ fontSize: '1rem' }}
      >
        {translate(name)}
      </Typography>
    </MenuItem>
  );

  return (
    <Fragment>
      {sidebarIsOpen || isOpen ? (
        header
      ) : (
        <Tooltip title={translate(name)} placement="right">
          {header}
        </Tooltip>
      )}
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List dense={dense} component="div" disablePadding>
          {children}
        </List>
      </Collapse>
    </Fragment>
  );
};

export default SubMenu;
